import { render, staticRenderFns } from "./simple-progress-chart.vue?vue&type=template&id=7827a884"
import script from "./simple-progress-chart.vue?vue&type=script&lang=js"
export * from "./simple-progress-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports